import React, {useEffect} from "react";
import "./spinner.css";
import blackBackground from "../../assets/pictures/old-black-background.jpg";

export default function LoadingSpinner(props) {

    useEffect(() => {
        props.handleFetch()
    }, [props]);

    return (
        <div  style={{
            backgroundImage: `url(${blackBackground})`,
            backgroundSize: "cover",
        }} className="spinner-container">
            <div className="loading-spinner">
            </div>
        </div>
    );
}